export class WindowOpener {
    constructor(options) {
        this.popup = null;
        this.destroy = () => {
            window.removeEventListener("message", this.listener);
        };
        this.onClose = () => { };
        this.onMessage = () => { };
        this.open = () => new Promise((resolve, reject) => {
            const popup = window.open(this.options.url, this.options.windowTarget, this.options.windowFeatures);
            if (popup) {
                this.popup = popup;
                this.listen();
                resolve();
            }
            else {
                reject(new Error("Can't open popup window"));
            }
        });
        this.listener = (event) => {
            if (!this.options.url.includes(event.origin))
                return;
            this.onMessage(event.data);
        };
        this.options = options;
    }
    listen() {
        const { popup } = this;
        if (popup) {
            window.addEventListener("message", this.listener);
            const watcher = setInterval(() => {
                if (popup.closed) {
                    this.onClose();
                    clearInterval(watcher);
                    window.removeEventListener("message", this.listener);
                }
            });
        }
    }
}
//# sourceMappingURL=window.js.map